import { ISection } from '@playbook-technologies/common-schemas';
import { UseFormReturn } from 'react-hook-form';
import { toast } from 'react-hot-toast';

export function useSections(
  formMethods: UseFormReturn<any>,
  sectionsPath = 'sections',
) {
  const { watch, setValue } = formMethods;

  const deleteSection = (index: number) => () => {
    if (index <= 0) return;
    const sections = watch(sectionsPath);
    const newSections = [...sections];
    newSections.splice(index, 1);
    setValue(sectionsPath, newSections);
  };

  const handleSectionChange = (index: number) => (newState: any) => {
    const section = watch(`${sectionsPath}.${index}`);
    setValue(`${sectionsPath}.${index}`, { ...section, ...newState });
  };

  const handleHeroSwitch = (name: ISection['type']) => {
    const section = watch(`${sectionsPath}.0`);
    setValue(`${sectionsPath}.0`, { ...section, type: name } as ISection);
  };

  const handleSectionMove = (index: number) => (moveBy: number) => {
    const sections = watch(sectionsPath);
    const newSections = [...sections];
    const movedSection = newSections.splice(index, 1)[0];
    newSections.splice(index + moveBy, 0, movedSection);
    setValue(sectionsPath, newSections);
  };

  const duplicateSection = (index: number) => () => {
    if (index <= 0) return;
    const sections = watch(sectionsPath);
    const newSections = [...sections];
    newSections.splice(index + 1, 0, {
      ...newSections[index],
    });
    setValue(sectionsPath, newSections);
    toast.success('Section duplicated successfully!');
  };

  return {
    duplicateSection,
    deleteSection,
    handleSectionChange,
    handleHeroSwitch,
    handleSectionMove,
  };
}
